var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent, createElement } from 'react';
import { map } from 'lodash';
import { default as AntTabs } from 'antd/lib/tabs';
import { Icon } from 'antd';
import { ComponentsManager } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
var AntTabPane = AntTabs.TabPane;

var Tabs = function (_super) {
  __extends(Tabs, _super);

  function Tabs(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (key) {
      _this.setState({
        activeKey: key
      });
    };

    var defaultActiveKey = props.defaultActiveKey;
    _this.state = {
      activeKey: defaultActiveKey
    };
    return _this;
  }

  Tabs.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        style = _a.style,
        items = _a.items,
        animated = _a.animated,
        defaultActiveKey = _a.defaultActiveKey,
        size = _a.size,
        tabBarStyle = _a.tabBarStyle,
        tabPosition = _a.tabPosition;
    var props = {
      className: className,
      style: style,
      animated: animated,
      size: size,
      tabBarStyle: tabBarStyle,
      tabPosition: tabPosition,
      onChange: this.onChange,
      activeKey: this.state.activeKey,
      defaultActiveKey: defaultActiveKey
    };

    if (defaultActiveKey) {
      props.defaultActiveKey = defaultActiveKey;
    }

    return React.createElement(AntTabs, __assign({}, props), map(items, function (item, index) {
      return _this.renderItem(item, index);
    }));
  };

  Tabs.prototype.renderItem = function (item, index) {
    var _a = this.props,
        entity = _a.entity,
        entities = _a.entities,
        routes = _a.routes,
        params = _a.params,
        children = _a.children,
        cache = _a.cache;
    var className = item.className,
        style = item.style,
        title = item.title,
        icon = item.icon,
        forceRender = item.forceRender,
        tabParams = item.params,
        content = item.content;

    if (item.privilege) {
      var _b = item.privilege,
          path = _b.path,
          level = _b.level;

      if (!services.privilege.check(path, level)) {
        return undefined;
      }
    }

    var itemProps = {
      key: index + '',
      className: className,
      style: style,
      forceRender: forceRender,
      tab: React.createElement("span", null, icon ? React.createElement(Icon, {
        type: icon
      }) : undefined, title)
    };
    var ContentComponent = ComponentsManager.get(content.component);

    var contentProps = __assign(__assign({}, content), {
      entity: entity,
      entities: entities,
      routes: routes,
      params: __assign(__assign({}, params), tabParams)
    });

    delete contentProps.component; //如果不使用缓存的时候，每次切换都要刷新数据

    if (!cache && this.state.activeKey !== index + '') {
      return React.createElement(AntTabPane, __assign({}, itemProps));
    }

    return React.createElement(AntTabPane, __assign({}, itemProps), createElement(ContentComponent, contentProps, children));
  };
  /**
   * Tabs组件默认使用缓存策略，同时默认显示的标签为第一个
   * @type {{defaultActiveKey: string, cache: boolean}}
   */


  Tabs.defaultProps = {
    defaultActiveKey: '0',
    cache: true
  };
  return Tabs;
}(PureComponent);

export { Tabs };